import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { StoreLocatorHelpBg } from '@next-nx/shared-ui/icons'
import { Button, WContainer } from '@next-nx/shared-ui/atoms'
import { useTealium } from '@next-nx/hooks'
import { getTimestamp } from '@next-nx/utils'
import styles from './StoreLocatorHelpBanner.module.sass'
import BoxLink from '../../molecules/BoxLink/BoxLink'


interface Props {
  item: MenuItemType
  boxLinkItem?: MenuItemType
  className?: string
}

const StoreLocatorHelpBanner = (props: Props) => {

  const { 
    item = undefined,
    boxLinkItem = undefined,
    className = '',
  } = props

  const { linkDataLayer } = useTealium()

  const handleTracking = (action_type?: string, c?: string, t?: string, cta?: string, key?: number) => {
    const action_timestamp = getTimestamp()
    let dlObj = {};

    switch (key) {
      case 1:
        dlObj = {
          virtual: 'action',
          action_name: 'contattaci',
          action_tech: 'click',
          action_type: 'accedi',
          action_timestamp,
          action_effect: 'accesso_pagina_contatti',
        }
        break;
      default:
        dlObj = {
          virtual: 'action',
          action_name: 'navigazione',
          action_tech: 'click',
          action_type: cta?.replace(/ /g, '_').toLowerCase(),
          action_timestamp,
          action_effect: 'interazione_componente_storelocator',
        }
        break;
    }
    linkDataLayer(dlObj)
  }

  return item ? (
    <div className={`${styles.root} ${boxLinkItem ? styles['root--box-link'] : ''} ${className}`}>
      <div className={`${styles.main}`}>
        <div className={`${styles.bg} ${styles['bg--desktop']}`}>
          <StoreLocatorHelpBg />
        </div>
        <WContainer>
          <div className={styles.content}>
            {!!item.name && <p className={styles.title}>{item.name}</p>}
            {!!item.url && !!item.ctaLabel && (
              <div className={styles.ctaBox}>
                <Button href={item.url} newPage={item.blank} label={item.ctaLabel} variant="secondary" color="white" handleTracking={(ty, c, t, cta) => {
                  handleTracking('', '', '', cta)
                  handleTracking('', '','','', 1)
                  }} />
              </div>
            )}
          </div>
        </WContainer>
      </div>
      {!!boxLinkItem && (
        <BoxLink item={boxLinkItem} className={styles.boxLink} handleTracking={handleTracking} />
      )}
    </div>
  ) : <></>
}

export default StoreLocatorHelpBanner
